import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import { PageHeader } from "@/components/common/DashboardBits";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function ExecutivesView() {
  const { t } = useLang();
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/executives").then((r) => setList(r.data)); }, []);
  return (
    <div>
      <PageHeader title={t("executives")} subtitle="Read-only directory" />
      <Card className="border border-slate-200">
        <CardContent className="p-0 overflow-x-auto">
          <Table>
            <TableHeader><TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Contact</TableHead>
              <TableHead>Location</TableHead>
              <TableHead>Radius</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {list.map((e) => (
                <TableRow key={e.id} data-testid={`office-exec-row-${e.id}`}>
                  <TableCell className="font-medium">{e.name}</TableCell>
                  <TableCell className="text-slate-600 text-xs">{e.email}<br/>{e.phone}</TableCell>
                  <TableCell className="text-slate-600">{e.working_location}</TableCell>
                  <TableCell className="num text-slate-600">{e.working_radius_km} km</TableCell>
                </TableRow>
              ))}
              {list.length === 0 && <TableRow><TableCell colSpan={4} className="text-center text-slate-500 py-8">No executives.</TableCell></TableRow>}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
